var React = require('react');

function NewSearch (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Artboard","fill":"#3A66E5","fillRule":"nonzero"},React.createElement("path",{"d":"M7.12367724,12.2747652 C4.28314875,12.2747652 1.97258923,9.96420572 1.97258923,7.12367724 C1.97258923,4.28314875 4.28314875,1.97258923 7.12367724,1.97258923 C9.96289067,1.97258923 12.2734502,4.28314875 12.2734502,7.12367724 C12.2734502,9.96420572 9.96289067,12.2747652 7.12367724,12.2747652 M15.7110157,14.3170526 L12.800789,11.406826 C13.7042349,10.212752 14.2460394,8.73199499 14.2460394,7.12367724 C14.2460394,3.19559455 11.0504449,0 7.12367724,0 C3.19559455,0 0,3.19559455 0,7.12367724 C0,11.0517599 3.19559455,14.2473545 7.12367724,14.2473545 C8.73199499,14.2473545 10.214067,13.7042349 11.406826,12.8021041 L14.3170526,15.7110157 C14.5090513,15.9043294 14.7615427,16.0003288 15.0140342,16.0003288 C15.2665256,16.0003288 15.519017,15.9043294 15.7110157,15.7110157 C16.0963281,15.3257032 16.0963281,14.7023651 15.7110157,14.3170526","id":"new-search"}))));
}

NewSearch.displayName = "NewSearch";

NewSearch.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = NewSearch;

NewSearch.default = NewSearch;



//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/assets/icons/new-search.svg
// module id = 1557
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16